import styled from 'styled-components/native';
import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  margin: 0 24px;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const Card = styled.View<{disabled?: boolean}>`
  margin-top: ${RFValue(10)}px;
  border-radius: ${RFValue(14)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
  background-color: ${({theme}) => theme.colors.price_card};
  shadow-color: #000;
  shadow-offset: 0px 4px;
  shadow-opacity: 0.08;
  shadow-radius: 10px;
  elevation: 2;
  opacity: ${({disabled}) => (disabled ? 0.7 : 1)};
`;

export const CardHeader = styled.View`
  padding: ${RFValue(12)}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const LimitBlock = styled.View`
  flex: 1;
`;

export const LimitLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.text};
  letter-spacing: 0.3px;
`;

export const LimitValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(15)}px;
  color: ${({theme}) => theme.colors.title};
  margin-top: ${RFValue(2)}px;
`;

export const ActionButton = styled.TouchableOpacity<{disabled?: boolean}>`
  padding: ${RFValue(10)}px ${RFValue(12)}px;
  border-radius: ${RFValue(10)}px;
  background-color: ${({theme}) => theme.colors.primary};
  opacity: ${({disabled}) => (disabled ? 0.6 : 1)};
  margin: 0 ${RFValue(12)}px;
  margin-top:${RFValue(4)}px;
  margin-bottom: ${RFValue(6)}px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${RFValue(4)}px;

`;

export const ActionText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.buttonTitle};
  text-align: center;
`;

export const BannerSlot = styled.View`
  width: 100%;
  
  padding:0 ${RFValue(12)}px;
  padding-bottom: ${RFValue(9)}px;
`;

export const BannerPlaceholder = styled.View`
  height: ${RFValue(68)}px;
  border-radius: ${RFValue(10)}px;
  background-color: ${({theme}) => theme.colors.background_secondary};
  align-items: center;
  justify-content: center;
`;

export const BannerText = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const BannerCarouselWrapper = styled.View`
  margin: 0;
  align-items: center;
`;

export const BannerPanel = styled.TouchableOpacity`
  flex: 1;
  border-radius: ${RFValue(12)}px;
  overflow: hidden;
`;

export const BannerImage = styled(FastImage)`
  width: 100%;
  aspect-ratio: 3.72;
  border-radius: ${RFValue(12)}px;
`;

export const HeaderRefreshButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}px;
`;

export const HeaderRefreshIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const HeaderRefreshText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text};
`;

export const StatementButton = styled.TouchableOpacity`
  margin: ${RFValue(12)}px 0 ${RFValue(12)}px ${RFValue(12)}px;
  align-self: flex-start;
  padding: 0;
`;

export const StatementText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
  text-decoration-line: underline;
  text-decoration-color: ${({theme}) => theme.colors.blue};
`;
